export default __webpack_public_path__ + "static/media/frilly-butt.6d1c6d1f.jpg";